export interface IMarketing {
  _id: string;
  name: string;
  date: string;
  value: number;
};

export interface IMarketingValues {
  min: number;
  max: number;
}

export const marketingValues: IMarketingValues = {
  min: 0,
  max: 3
};

export const marketingLabels = ['None', 'Low', 'Medium', 'High'];
